export const environment = {
  production: false,
  APIUrl: 'https://iima-api.ilizien-projects-cdf.in',
  version: '1.0.0',
  appName: 'IIMA Portal',
  defaultLanguage: 'en',
  apiTimeout: 30000, // 30 seconds
  CRYPTO_KEY: 'wHLHsHeTcFvW11LBjnE4tE6sz',
  SECRET_KEY: 'V1VWTVRFOVhJRk5WUWsxQlVrbE9SUT09LFRrOUNUMFJaSUZkSlRFd2dTMDVQVnc9PQ==',


}; 
